
  (function() {
    function initSwatchImageSwap() {
      document.querySelectorAll('.card-variant-link[data-product-id]').forEach(function(swatch) {
        swatch.addEventListener('click', function(e) {
          e.preventDefault();

          var productId = this.getAttribute('data-product-id');
          var mainImgSrc = this.getAttribute('data-main-img');
          var hoverImgSrc = this.getAttribute('data-hover-img');
          var mainSrcset = this.getAttribute('data-main-srcset');
          var hoverSrcset = this.getAttribute('data-hover-srcset');
          var variantUrl = this.getAttribute('href');
          var variantId = this.getAttribute('data-variant-id'); // ✅ variant ID fetch

          // Active swatch class update
          document.querySelectorAll('.card-variant-link[data-product-id="' + productId + '"]').forEach(function(s) {
            s.classList.remove('active-swatch');
          });
          this.classList.add('active-swatch');

          // Primary image update
          var primaryImg = document.getElementById('card-primary-img-' + productId);
          if (primaryImg && mainImgSrc) {
            primaryImg.src = mainImgSrc;
            if (mainSrcset) primaryImg.srcset = mainSrcset;
          }

          // Hover image update
          var hoverImg = document.getElementById('card-hover-img-' + productId);
          if (hoverImg && hoverImgSrc) {
            hoverImg.src = hoverImgSrc;
            if (hoverSrcset) hoverImg.srcset = hoverSrcset;
          }

          // Card wrapper
          var cardWrapper = primaryImg ? primaryImg.closest('.card-wrapper') : null;
          if (cardWrapper) {

            // ✅ Hidden variant input update - selected variant cart mein jaaye
            var variantInput = cardWrapper.querySelector('input.product-variant-id');
            if (variantInput && variantId) {
              variantInput.value = variantId;
            }

            // Card links update
            cardWrapper.querySelectorAll('a.full-unstyled-link, a[id^="CardLink"], a[id^="StandardCardNoMediaLink"]').forEach(function(link) {
              link.href = variantUrl;
            });
          }
        });
      });
    }

    // DOM ready check
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSwatchImageSwap);
    } else {
      initSwatchImageSwap();
    }
  })();
